import React, { useEffect, useState } from "react";
import vehicle from "../../images/Car.png";
import bike from "../../images/bikethumbnail.png";
import IndianNumberPlate from "../../images/IndianNumberPlate.png";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { HiMiniChevronDown, HiMiniChevronUp } from "react-icons/hi2";
import { MdOutlineFileDownload } from "react-icons/md";
import axios from "axios";
import NoDataFound from "../../components/NoDataFound";
import ImageLoading from "../../components/ImageLoading";
import IndividualVehicle from "../IndividualAssets/Vehicle/IndividualVehicle";

function VehicleAnalyzer({ id }) {
  const token = localStorage.getItem("token");
  const lender_id = localStorage.getItem("lender_uuid");

  const [holdingData, setHoldingData] = useState([
    "All Holding",
    "Broker 1",
    "Broker 2",
    "Broker 3",
    "Broker 4",
    "Broker 5",
  ]);
  const [holdingSelected, setHoldingSelected] = useState("All Holding");
  const [openHoldingMore, setOpenHoldingMore] = useState(false);
  const [more, setMore] = useState(false);
  const [expand, setExpand] = useState(false);
  const [expandAnalytics, setExpandAnalytics] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [holdingDetails, setHoldingDetails] = useState("");
  const [stocksData, setStocksData] = useState([1, 2, 3, 4, 5, 6]);
  const [showView, setShowView] = useState(false);
  const [showViewAnalytics, setShowViewAnalytics] = useState(false);
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);

  const [recordArray, setRecordArray] = useState([]);
  const [noDownload, setNoDownload] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [singleVehicleView, setSingleVehicleView] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState({});

  const calculateTotalAmount = (res) => {
    let temp = 0;
    res.response.map((item) => {
      // let temp = totalPrice;
      let fixed = parseFloat(item.current_price);
      temp = temp + fixed;

      // setTotalPrice(temp);
    });
    setTotalPrice(temp);
  };

  const fetchRecordId = (assetArray) => {
    let flagArray = [];
    assetArray.forEach((item) => {
      flagArray = [...flagArray, ...item.record_ids];
    });
    setRecordArray(flagArray);
  };

  const fetchAssetGateway = async () => {
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/asset_gateway`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res?.data?.asset_gateway?.vehicle?.length > 0) {
        fetchRecordId(res.data.asset_gateway.vehicle);
        setLoading(false);
      } else {
        setNoDownload(true);
      }
    } catch (error) {}
  };

  const VehicleDataHolding = async () => {
    setLoading(true);
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/tartan_graph/${lender_id}?user_id=${id}`,
        method: "GET",
        headers: { Authorization: token, "Content-Type": "application/json" },
      };
      const res = await axios(options);
      if (res?.data?.response !== null) {
        setHoldingDetails(res.data);
        calculateTotalAmount(res.data);
        fetchAssetGateway();
        setNoData(false);
      } else {
        setLoading(false);
        setHoldingDetails("");
        setNoData(true);
      }
    } catch (error) {
      setHoldingDetails("");
      setNoData(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    VehicleDataHolding();
  }, []);

  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    num = parseFloat(num);
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }

  function truncateText(text, maxLength) {
    if (text === null) return "---";
    if (text.length > maxLength) {
      return text.slice(0, maxLength - 3) + "...";
    }
    return text;
  }

  const handleExcelDownload = async (assetName) => {
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/download_as_excel`,
        method: "POST",
        headers: { Authorization: token },
        data: {
          asset_name: assetName,
          record_ids: recordArray,
        },
      };
      const res = await axios(options);
      if (res.data.url.status) {
        const url = res.data.url.data;
        handleDownloadFile(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <>
      {!singleVehicleView && (
        <>
          {noData && (
            <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
              <NoDataFound />
            </div>
          )}
          {loading && (
            <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
              <ImageLoading />
            </div>
          )}
          {!noData && !loading && (
            <div className=" mt-4 w-full overflow-auto h-[calc(100vh-190px)]">
              <div className="flex flex-row justify-between gap-2">
                <div className="flex flex-col justify-between gap-3 w-[49.4%] h-full">
                  <div
                    className={`bg-white rounded-lg w-full p-3 ${
                      expand ? "h-fit" : "h-fit"
                    }`}
                  >
                    <p className="text-[#262626] font-semibold text-base">
                      Vehicle Holding
                    </p>
                    <div
                      className={`${
                        expand && holdingDetails?.response?.length > 5
                          ? "overflow-y-scroll h-[60vh]"
                          : expand && holdingDetails?.response?.length <= 5
                          ? "overflow-y-scroll h-fit"
                          : !expand && holdingDetails?.response?.length > 3
                          ? "overflow-y-hidden h-[292px]"
                          : "overflow-y-hidden h-fit"
                      }`}
                    >
                      {holdingDetails.response?.map((data, index) => {
                        return (
                          <div
                            onClick={() => {
                              setSelectedVehicle({
                                id: data.application_id,
                              });
                              setSingleVehicleView(true);
                            }}
                            key={index}
                            className="mt-4 flex flex-row justify-between items-center border border-solid border-[#E6EBED] p-3 rounded-lg hover:shadow-lg cursor-pointer"
                          >
                            <div className="flex flex-row items-center justify-start basis-[80%] gap-3">
                              <img
                                src={data?.category === "Bike" ? bike : vehicle}
                                width="45"
                                height="45"
                                alt="vehicle"
                                className=""
                              />
                              <div className="flex flex-col justify-start items-start">
                                <p
                                  className="text-xs font-semibold text-[#262626]"
                                  // title={
                                  //   data?.model_name?.length > 24 && data.model_name
                                  // }
                                >
                                  {data.model_name}
                                  {/* {truncateText(data.model_name, 65) || "---"} */}
                                </p>
                                <div className="flex items-center rounded-sm bg-black px-2 py-1 ">
                                  <div className=" w-[15px] h-[15px] rounded-[1px] bg-[#08428d] flex justify-center items-center ">
                                    <img
                                      src={IndianNumberPlate}
                                      width="9"
                                      height="7"
                                      alt="Indian vehicle Plate"
                                      className=""
                                    />
                                  </div>
                                  <p className="  ml-2 text-xs font-semibold text-white">
                                    {data.vehicle_number || "---"}
                                  </p>
                                </div>
                              </div>
                            </div>
                            {/* <div className="flex flex-col justify-start items-start mr-auto gap-1">
                          <p className="text-xs font-medium text-[#8B8B8B]">
                            Insurance
                          </p>
                          <div className=" text-[10px] flex items-center font-medium">
                            <p className=" rounded-xl bg-[#dbe8db] text-[#0ba300] px-[10px] py-[3px] mr-2">
                              Active
                            </p>
                            <p className=" ">Valid till : Nov 12, 2024 </p>
                          </div>
                        </div> */}
                            <div className="flex flex-col justify-start items-start gap-1">
                              <p className="text-xs font-medium text-[#8B8B8B]">
                                Current Value
                              </p>
                              <p className="text-xs font-medium text-[#262626]">
                                {formatToIndianRupees(data.current_price) ||
                                  "---"}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    {holdingDetails?.response?.length > 3 && (
                      <div className="flex flex-row justify-center items-center mt-4">
                        {expand ? (
                          <p
                            className="text-xs font-semibold text-[#262626] cursor-pointer"
                            onClick={() => setExpand(false)}
                          >
                            Less
                          </p>
                        ) : showView ? (
                          <p
                            className="text-xs font-semibold text-[#262626] cursor-pointer"
                            onClick={() => setExpand(true)}
                            onMouseOut={() => setShowView(false)}
                          >
                            View More
                          </p>
                        ) : (
                          <HiMiniChevronDown
                            className="cursor-pointer rounded-full border border-solid border-[#262626] animate-bounce"
                            color="#262626"
                            size={"25px"}
                            onMouseOver={() => setShowView(true)}
                          />
                        )}
                      </div>
                    )}
                  </div>
                  <div className={`bg-white rounded-lg full p-3 h-[120px]`}>
                    <p className="text-[#262626] font-semibold text-base">
                      Downloads
                    </p>
                    <div className="mt-4 flex flex-row justify-between items-center border border-solid border-[#E6EBED] p-3 rounded-lg">
                      <div className="flex flex-row justify-start items-center mr-auto ml-3">
                        <p className="text-xs font-semibold text-[#262626]">
                          Vehicle Anaysis
                        </p>
                      </div>
                      <div className="flex flex-row justify-start items-start">
                        <button
                          onClick={() => {
                            handleExcelDownload("vehicle");
                          }}
                          className={`px-4 py-1 flex flex-row items-center gap-2 rounded bg-white text-xs font-semibold text-[#00394d] border border-solid border-[#00394D]`}
                        >
                          <MdOutlineFileDownload
                            size={"20px"}
                            color="#00394D"
                          />
                          Download
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`bg-white rounded-lg w-[49.4%] p-3 h-fit`}>
                  <p className="text-[#262626] font-semibold text-base">
                    Analytics
                  </p>
                  <div className="flex flex-row justify-between items-center gap-3 mt-4">
                    <div className="flex flex-row justify-between items-start border border-solid border-[#E6EBED] p-3 rounded-lg basis-[50%]">
                      <div className="flex flex-col justify-start items-start gap-3">
                        <p className="text-xs font-bold text-[#262626]">
                          Total Current Value
                        </p>
                        <p className="text-lg font-semibold text-[#00394D]">
                          {formatToIndianRupees(totalPrice) || "---"}
                        </p>
                      </div>
                      <IoMdInformationCircleOutline
                        size={"20px"}
                        color="#00394d"
                      />
                    </div>
                    <div className="flex flex-row justify-between items-start border border-solid border-[#E6EBED] p-3 rounded-lg basis-[50%]">
                      <div className="flex flex-col justify-start items-start gap-3">
                        <p className="text-xs font-bold text-[#00394d]">
                          Number of Holding
                        </p>
                        <p className="text-lg font-semibold text-[#00394D]">
                          {" "}
                          {holdingDetails.total_value?.asset_count || "---"}
                        </p>
                      </div>
                      <IoMdInformationCircleOutline
                        size={"20px"}
                        color="#003994d"
                      />
                    </div>
                  </div>
                  {/* //// */}
                  {/* <div className="flex flex-row justify-between items-center gap-3 mt-4">
            <div className="flex flex-row justify-between items-start border border-solid border-[#E6EBED] p-3 rounded-lg basis-[50%]">
              <div className="flex flex-col justify-start items-start gap-3">
                <p className="text-xs font-bold text-[#262626]">
                  Total Active Challans
                </p>
                <p className="text-lg font-semibold text-[#d30d00]">10</p>
              </div>
              <IoMdInformationCircleOutline size={"20px"} color={"#00394d"} />
            </div>
            <div className="flex flex-row justify-between items-start border border-solid border-[#E6EBED] p-3 rounded-lg basis-[50%]">
              <div className="flex flex-col justify-start items-start gap-3">
                <p className="text-xs font-bold text-[#262626]">
                  Expired Insurance
                </p>
                <p className="text-lg font-semibold text-[#d30d00]">10</p>
              </div>
              <IoMdInformationCircleOutline size={"20px"} color="#262626" />
            </div>
          </div> */}
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {singleVehicleView && (
        <IndividualVehicle
          selectedVehicle={selectedVehicle}
          id={id}
          setSingleVehicleView={setSingleVehicleView}
        />
      )}
    </>
  );
}

export default VehicleAnalyzer;
